import PageMainTitle from 'components/commons/PageMainTitle'
import { pageMainTitle } from 'components/cases/Case/CaseItems'
import styles from './ListPage.module.scss'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
import AccordionNav from './common/fragments/AccordionNav'
import CaseStudyList from './common/fragments/CaseStudyList'
import NoCaseMessage from './common/fragments/NoCaseMessage'
import Pagination from 'components/topics/Pagination'
import { useState, useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { caseStudyItems } from 'components/cases/Case/CaseStudyItem' // データをインポート

gsap.registerPlugin(ScrollTrigger)

// 業界カテゴリ（これ以外はサービスカテゴリ扱い）
const industryCategoryTitles = [
  'IT/情報/通信',
  'メーカー/製造/建設',
  '金融/不動産',
  '小売/流通/卸',
  'サービス',
  '公共/行政',
]

interface ListPageProps {
  categoryTitle: string
  baseUrl: string
  pageId: number
}

const ListPage: React.FC<ListPageProps> = ({ categoryTitle, baseUrl, pageId }) => {
  const [isOpen, setIsOpen] = useState(false)
  const pageSize = 10

  // タグが一致するアイテムをフィルタリング
  const filteredItems = caseStudyItems.filter(
    (item) => item.tags.some((tag) => tag.tag === categoryTitle), // tags の中に categoryTitle が含まれているかチェック
  )

  const totalPages = Math.ceil(filteredItems.length / pageSize)
  const currentPage = pageId
  const currentItems = filteredItems.slice((currentPage - 1) * pageSize, currentPage * pageSize)

  const titleSuffix = industryCategoryTitles.includes(categoryTitle) ? ' 業界事例' : '事例'

  const titleRef = useRef<HTMLHeadingElement>(null)

  useEffect(() => {
    gsap.set(titleRef.current, { opacity: 0, y: 50 })
    gsap.to(titleRef.current, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: Power4.easeOut,
    })
  }, [])

  return (
    <article>
      <PageMainTitle
        pageMainTitle={pageMainTitle}
        paths={[
          { name: 'TOP', url: '/' },
          { name: 'Case study', url: '/cases' },
          { name: categoryTitle, url: '#' },
        ]}
      />

      <div className={styles.postContent}>
        <AccordionNav isOpen={isOpen} setIsOpen={setIsOpen} categoryTitle={categoryTitle} />

        <div className={styles.postContent_content}>
          <h2 className={styles.postContent_content_title} ref={titleRef}>
            {categoryTitle}
            {titleSuffix}
          </h2>

          {filteredItems.length > 0 ? <CaseStudyList items={currentItems} /> : <NoCaseMessage />}

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              getPageLink={(page) => `${baseUrl.replace(/\/$/, '')}/page/${page}`}
            />
          )}
        </div>
      </div>

      <MailmagazineLink />
    </article>
  )
}

export default ListPage

// import PageMainTitle from 'components/commons/PageMainTitle'
// import { pageMainTitle } from 'components/cases/Case/CaseItems'
// import styles from 'components/cases/listpage/ListPage.module.scss'
// import Link from 'next/link'
// import Button from 'components/commons/Button/Button'
// import Pagination from 'components/topics/Pagination'
// import SearchTagList from 'components/cases/listpage/common/SearchTagList'
// import { useState, useEffect, useRef } from 'react'
// import { gsap, Power4 } from 'gsap'
// import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
// import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

// gsap.registerPlugin(ScrollTrigger)

// interface CaseStudyItem {
//   projectName: string
//   client: string
//   description?: string
//   src: string
//   alt: string
//   id: string
//   tags: Array<{
//     tag: string
//     href: string
//   }>
//   isOneline: boolean
//   linkToDetail?: string
// }

// interface ListPageProps {
//   caseStudyItems: CaseStudyItem[]
//   categoryTitle: string
//   baseUrl: string
//   pageId: number
// }

// const ListPage: React.FC<ListPageProps> = ({ caseStudyItems, categoryTitle, baseUrl, pageId }) => {
//   const paths = [
//     { name: 'TOP', url: '/' },
//     { name: 'Case study', url: '/cases' },
//     { name: categoryTitle, url: '#' },
//   ]

//   const [isOpen, setIsOpen] = useState(false)
//   const pageSize = 10
//   const totalPages = Math.ceil(caseStudyItems.length / pageSize)
//   const currentPage = pageId

//   const getPageLink = (pageNumber: number) => `${baseUrl}/page/${pageNumber}`

//   const currentItems = caseStudyItems.slice((currentPage - 1) * pageSize, currentPage * pageSize)

//   const navRef = useRef<HTMLDivElement>(null)
//   const ulRef = useRef<HTMLUListElement>(null)
//   const nocaseRef = useRef<HTMLDivElement>(null)
//   const titleRef = useRef<HTMLHeadingElement>(null)

//   useEffect(() => {
//     const elements = ulRef.current?.querySelectorAll('li') || []
//     const nocaseElements = nocaseRef.current?.querySelectorAll('div, p, a') || []

//     gsap.set(elements, { opacity: 0, y: 50 })
//     gsap.set(navRef.current, { opacity: 0, y: 50 })
//     gsap.set(nocaseElements, { opacity: 0, y: 50 })
//     gsap.set(titleRef.current, { opacity: 0, y: 50 })

//     if (elements.length > 0) {
//       gsap.to(elements, {
//         opacity: 1,
//         y: 0,
//         duration: 1,
//         stagger: 0.2,
//         ease: Power4.easeOut,
//       })
//     } else if (nocaseRef.current) {
//       gsap.to(nocaseElements, {
//         opacity: 1,
//         y: 0,
//         duration: 1,
//         stagger: 0.2,
//         ease: Power4.easeOut,
//       })
//     }

//     gsap.to(navRef.current, {
//       opacity: 1,
//       y: 0,
//       duration: 0.6,
//       ease: Power4.easeOut,
//       scrollTrigger: {
//         trigger: navRef.current,
//         start: 'top 80%',
//         toggleActions: 'play none none reverse',
//       },
//     })

//     gsap.to(titleRef.current, {
//       opacity: 1,
//       y: 0,
//       duration: 1,
//       ease: Power4.easeOut,
//     })
//   }, [caseStudyItems])

//   const list = currentItems.map(({ projectName, client, id, tags, src, alt, linkToDetail }): JSX.Element => {
//     const content = (
//       <>
//         {linkToDetail ? (
//           <Link href={linkToDetail}>
//             <a href={linkToDetail} className={styles.caseitem_pic}>
//               <figure className={styles.caseitem_pic_img}>
//                 <img src={src} alt={alt} className={styles.caseitem_pic_img_item} />
//               </figure>
//             </a>
//           </Link>
//         ) : (
//           <div className={styles.caseitem_pic}>
//             <figure className={styles.caseitem_pic_img}>
//               <img src={src} alt={alt} className={styles.caseitem_pic_img_item} />
//             </figure>
//           </div>
//         )}
//         <div className={styles.caseitem_info}>
//           {linkToDetail ? (
//             <Link href={linkToDetail}>
//               <a href={linkToDetail} className={styles.caseitem_main}>
//                 <div className={styles.caseitem_main_project} dangerouslySetInnerHTML={{ __html: projectName }}></div>
//                 <div className={styles.caseitem_main_client}>{client}</div>
//               </a>
//             </Link>
//           ) : (
//             <div className={styles.caseitem_main}>
//               <div className={styles.caseitem_main_project} dangerouslySetInnerHTML={{ __html: projectName }}></div>
//               <div className={styles.caseitem_main_client}>{client}</div>
//             </div>
//           )}
//           <ul className={styles.caseitem_tag}>
//             {tags.map((tagItem, index) => (
//               <li key={`${tagItem.tag}-${index}`}>
//                 <a href={tagItem.href} className={styles.categoryButton} onClick={(e) => e.stopPropagation()}>
//                   {tagItem.tag}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </>
//     )

//     return (
//       <li key={id} className={styles.caseitem}>
//         {content}
//       </li>
//     )
//   })

//   return (
//     <article>
//       <PageMainTitle pageMainTitle={pageMainTitle} paths={paths} />
//       <div className={styles.postContent}>
//         <button className={`${styles.postContent_accordion} accordionBtn`} onClick={() => setIsOpen(!isOpen)}>
//           <span>サービスから探す</span>
//         </button>
//         <div className={`${styles.postContent_nav} accordionBody`} aria-hidden={!isOpen} ref={navRef}>
//           <div className={styles.allbtn}>
//             <Link href="/cases">すべてのサービス・業界</Link>
//           </div>
//           <SearchTagList currentCategory={categoryTitle} />
//           <div className={styles.contactPanel}>
//             <p className={styles.contactPanel_ttl}>Contact</p>
//             <p className={styles.contactPanel_desc}>
//               <span>お気軽にお問い合わ</span>
//               <span>せください</span>
//             </p>
//             <div className={styles.contactPanel_btn}>
//               <Button text="お問い合わせ" href="/contact" red="red" />
//             </div>
//           </div>
//         </div>
//         <div className={styles.postContent_content}>
//           <h2 className={styles.postContent_content_title} ref={titleRef}>
//             {categoryTitle}
//           </h2>
//           {caseStudyItems.length > 0 ? (
//             <ul className={styles.caselist} ref={ulRef}>
//               {list}
//             </ul>
//           ) : (
//             <div className={styles.nocase} ref={nocaseRef}>
//               <div className={styles.nocase_inner}>
//                 <div className={styles.nocase_inner_head}>
//                   <p className={styles.nocase_inner_head_main}>Coming soon</p>
//                   <p className={styles.nocase_inner_head_sub}>事例紹介準備中</p>
//                 </div>
//                 <div className={styles.nocase_inner_bottom}>
//                   <p className={styles.nocase_inner_bottom_text}>
//                     サービス詳細を別途ご案内可能です
//                     <br />
//                     お気軽にお問い合わせください
//                   </p>
//                   <Button text="お問い合わせ" href="/contact" red="red" />
//                 </div>
//               </div>
//             </div>
//           )}
//           {totalPages > 1 && (
//             <div className={styles.pagination}>
//               <Pagination currentPage={currentPage} totalPages={totalPages} getPageLink={getPageLink} />
//             </div>
//           )}
//         </div>
//       </div>
//       <MailmagazineLink />
//       <style>{`
//         @media (max-width: 719px) {
//           .accordionBtn {
//             border-bottom: ${isOpen ? 'unset' : '1px solid #444444'};
//           }
//           .accordionBtn::before {
//             transform: ${isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
//           }
//           .accordionBody {
//             max-height: ${isOpen ? '9999px' : 0};
//             transition: all 0.3s;
//             overflow: hidden;
//           }
//         }
//       `}</style>
//     </article>
//   )
// }

// export default ListPage
